import React from "react";

const PersonalInfo = ({ profileData }) => {
    if (!profileData) return null;

    return (

        <div className="personal-info-box" style={{ marginBottom:"20px"}}>
            <h4 className="title_roolt_checkout">
                Personal Information
            </h4>

            <div className="root_track">
                <div className="row trackrow">
                    <div className="per-row-input">
                        <input
                            type="text"
                            value={profileData?.first_name || ""}
                            placeholder="First Name"
                            className="input_checkout"
                            readOnly
                        />
                        <input
                            type="text"
                            value={profileData?.last_name || ""}
                            placeholder="Last Name"
                            className="input_checkout"
                            readOnly
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="per-row-input">
                        <input
                            type="email"
                            value={profileData?.email || ""}
                            placeholder="Email"
                            className="input_checkout"
                            readOnly
                        />
                        <input
                            type="tel"
                            value={
                                profileData?.mobile
                                    ? `+91 ${profileData.mobile}`
                                    : ""
                            }
                            placeholder="Mobile"
                            className="input_checkout"
                            readOnly
                        />
                    </div>
                </div>
            </div>
        </div>

    );
};

export default PersonalInfo;
